/* import __COLOCATED_TEMPLATE__ from './subscription-type-item.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();